module.exports = __webpack_public_path__ + "media/images/icons/outlined/zoom-out-ebcdd960cdfda27a79c189c0c2dcaaa0.svg";